import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabaseEh } from '@/lib/supabase'
import type { Database } from '@/types/database'

type Character = Database['eh']['Tables']['characters']['Row'];

// TODO: query and store all characters here

const fetchCharacter = async (characterId: string): Promise<Character | null> => {
  const { data, error } = await supabaseEh
    .from('characters')
    .select('*')
    .eq('id', characterId)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return data
}

const updateCharacter = async (
  characterData: Partial<Character> & { id: string },
) => {
  const { id, ...updateData } = characterData
  const { data, error } = await supabaseEh
    .from('characters')
    .update(updateData)
    .eq('id', id)
    .select()
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export const useCharacter = (characterId: string) => {
  return useQuery<Character | null, Error>({
    queryKey: ['character', characterId],
    queryFn: () => fetchCharacter(characterId),
    enabled: !!characterId,
  })
}

export const useUpdateCharacter = () => {
  const queryClient = useQueryClient()

  return useMutation<Character, Error, Partial<Character> & { id: string }>({
    mutationFn: updateCharacter,
    onSuccess: (data) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['character', data.id] })
        queryClient.invalidateQueries({ queryKey: ['characters'] })
      }
    },
  })
} 